import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import FeaturedVideos from './components/FeaturedVideos';
import CategoryGrid from './components/CategoryGrid';
import BrandFeatures from './components/BrandFeatures';
import Testimonials from './components/Testimonials';
import TrendingTopics from './components/TrendingTopics';
import FAQSection from './components/FAQSection';
import DownloadSection from './components/DownloadSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'mogu视频 - 蘑菇街视频购物官方平台',
            description:
              'mogu视频是蘑菇街旗下专注时尚购物的短视频平台，汇聚海量穿搭教程、美妆测评、潮流单品视频内容。',
            url: 'https://www.mogu-video.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: 'mogu视频',
              url: 'https://www.mogu-video.com/',
            },
            mainEntity: {
              '@type': 'Organization',
              name: 'mogu视频',
              url: 'https://www.mogu-video.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'mogu视频是什么平台？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'mogu视频是蘑菇街旗下的时尚购物短视频平台，专注于穿搭教程、美妆测评、潮流单品推荐等内容。用户可以在观看视频的同时直接购买视频中展示的商品，实现边看边买的沉浸式购物体验。',
                },
              },
              {
                '@type': 'Question',
                name: '如何在mogu视频上购物？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '在观看视频时，点击视频下方的商品链接即可查看详细信息和价格。您可以直接在mogu视频App内完成下单购买，享受便捷的一站式视频购物体验。',
                },
              },
              {
                '@type': 'Question',
                name: 'mogu视频的内容质量如何保证？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们拥有严格的内容审核机制和达人认证体系。所有入驻的时尚达人都经过专业筛选和培训，确保为用户提供高质量、有价值的时尚内容。',
                },
              },
              {
                '@type': 'Question',
                name: '如何在mogu视频上成为创作者？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过mogu视频App内的创作者中心申请入驻。我们欢迎热爱时尚、有创作热情的用户加入。通过审核后，即可开始发布视频内容。',
                },
              },
              {
                '@type': 'Question',
                name: '视频中的商品如何保证正品？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'mogu视频与蘑菇街共享供应链体系，所有在平台销售的商品均经过严格的正品审核。我们与品牌方和授权经销商直接合作，确保每一件商品都是正品。',
                },
              },
            ],
          }),
        }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <StatsBar />
        <FeaturedVideos />
        <CategoryGrid />
        <BrandFeatures />
        <Testimonials />
        <TrendingTopics />
        <FAQSection />
        <DownloadSection />
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}